import { render, staticRenderFns } from "./AppPreloader.vue?vue&type=template&id=a296d872&scoped=true&"
import script from "./AppPreloader.vue?vue&type=script&lang=js&"
export * from "./AppPreloader.vue?vue&type=script&lang=js&"
import style0 from "./AppPreloader.vue?vue&type=style&index=0&id=a296d872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a296d872",
  null
  
)

export default component.exports